module.exports = __webpack_public_path__ + "assets/fonts/Roboto-Thin.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/roboto/Roboto-Thin.woff2
// module id = 692
// module chunks = 0